import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import PageContent from '../../components/page-content';
import PageHeader from '../../components/page-header';
import FeaturedArticle from '../landing-page/components/featured-article';
import { plainText } from '../editorial-content/components/slices/rich-text';

import { PrismicArticleConnection } from '../../types';
import * as S from './styles';

type Data = {
  prismicArticles: PrismicArticleConnection;
};

export type Props = {
  data: Data;
};

const getBreadcrumbPath = ({
  name,
  pathName,
}: {
  name: string;
  pathName: string;
}) => [
  {
    id: 'articles',
    name,
    pathName,
  },
];

const EditorialContentListingPage = ({ data }: Props) => {
  const { t, linkTo } = useContext(AppContext);

  return (
    <PageContent withAds>
      <Breadcrumb
        firstPathSelectable={false}
        homeText={t('common', 'breadcrumb.home')}
        path={getBreadcrumbPath({
          name: t('common', 'article.articles'),
          pathName: linkTo('editorialContentListing'),
        })}
      />
      <PageHeader title={t('common', 'article.articles')} />
      <S.ArticleListWrapper>
        {data?.prismicArticles?.nodes?.map(article => {
          return (
            <Panel key={article.id} header={<PanelHeader />}>
              <FeaturedArticle
                key={article.id}
                pathName={article.pathName}
                imageUrl={article.data.featuredImage?.url}
                title={plainText(article.data.title)}
                preamble={plainText(article.data.metaDescription)}
                linkText={t('landing', 'featured-article.read-more')}
              />
            </Panel>
          );
        })}
      </S.ArticleListWrapper>
    </PageContent>
  );
};

export default EditorialContentListingPage;
